<template>
  <div id="popup-modals-container">
    <!-- Modal -->
    <div
      class="modal fade "
      id="exampleModalCenter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered login-modal"
        role="document"
      >
        <div class="modal-content ">
          <div class="modal-header">
            <h3
              class="modal-title login-modal-title"
              id="exampleModalLongTitle1"
            >
              Login / Sign Up
            </h3>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span
                aria-hidden="true"
                id="signin-mob-close"
              >
                &times;
              </span>
            </button>
          </div>
          <div class="modal-body login-modal-body">
            <p
              class="text-center d-block mx-auto"
              id="signin-mob-para"
            >
              Please enter your Email to Sign Up.
            </p>
            <form>
              <div class="number-prefix">
                <input
                  class="col-12 form-control login-signup-input"
                  type="text"
                  placeholder="Email"
                  data-ismobileonly="false"
                  name="username"
                  id="signin-mob-username"
                >
              </div>
              <button
                class="btn col-12 btn-lg blue-btn continue-btn mt-2"
                id="signin-mob-continue-btn"
              >
                Continue
              </button>
            </form>

          </div>
        </div>
      </div>
    </div>
    <sign-up-modal-flow-one>
    </sign-up-modal-flow-one>
    <div
      class="modal fade "
      id="verification-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered login-modal"
        role="document"
      >
        <div class="modal-content ">
          <div class="modal-header">
            <h3
              class="modal-title login-modal-title"
              id="exampleModalLongTitle2"
            >
              Sign Up
            </h3>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span
                aria-hidden="true"
                id="signup-close"
              >
                &times;
              </span>
            </button>
          </div>
          <div class="modal-body login-modal-body">
            <p
              class="text-left"
              id="signup-para"
            >
              Please enter verification code (OTP) sent to:
            </p>
            <form>
              <div class="number-prefix">
                <input
                  class="col-12 form-control login-signup-input
                border-dashed w-75 mx-auto"
                  type="text"
                  placeholder="8822468412"
                  data-ismobileonly="false"
                  name="username"
                  id="signup-username"
                >
                <hr>
                <input
                  class="col-12 form-control login-signup-input
                 otp-code-input mx-auto"
                  type="text"
                  placeholder="code"
                  data-ismobileonly="false"
                  name="username"
                  id="signup-code"
                >
              </div>
              <a
                class="text-center mx-auto d-block mt-3"
                href="#"
                id="signup-resend-btn"
              >
                Resend OTP
              </a>
              <button
                class="btn col-12 btn-lg blue-btn continue-btn mt-3 mb-2"
                id="signup-continue-btn-popup-model"
              >
                Continue
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade "
      id="login-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered login-modal"
        role="document"
      >
        <div class="modal-content ">
          <div class="modal-header">
            <h3
              class="modal-title login-modal-title"
              id="exampleModalLongTitle3"
            >
              Login
            </h3>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span
                aria-hidden="true"
                @click.prevent="resetLoginFormData()"
                id="login-close"
              >
                &times;
              </span>
            </button>
          </div>
          <div class="modal-body login-modal-body">
            <p
              class="text-left"
              id="login-para"
            >
              Please enter your Email to Login
            </p>
            <login-form>
            </login-form>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Login-->
    <!-- Modal forgot password -->
    <div
      class="modal fade "
      id="forgotpswd-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered login-modal"
        role="document"
      >
        <div class="modal-content ">
          <div class="modal-header">
            <h3
              class="modal-title login-modal-title"
              id="exampleModalLongTitle4"
            >
              Reset Password
            </h3>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span
                aria-hidden="true"
                @click.prevent="resetResetPasswordData"
                id="login-mob-close"
              >
                &times;
              </span>
            </button>
          </div>
          <div class="modal-body login-modal-body">
            <!-- hide after click -->
            <request-reset-password-form>
            </request-reset-password-form>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal forgot password-->
  </div>
</template>

<script>

import SignUpModalFlowOne from '@/components/shared/modals/widgets/SignUpModal-FlowOne'
import LoginForm from '@/components/pages/login/forms/LoginForm'
import RequestResetPasswordForm from '@/components/pages/resetPassword/forms/ForgotPasswordForm'

export default {
	components: {
		LoginForm,
		SignUpModalFlowOne,
		RequestResetPasswordForm
	},
	methods: {
		resetLoginFormData () {
			this.$root.$emit('LoginFormClear')
		},
		resetResetPasswordData () {
			this.$root.$emit('ResetPasswordFormClear')
		}
	}
}
</script>
